import { isPreEsistente } from '@slims/shared/calculations';
import type { MemberMeterFields } from '@slims/ui/organisms';
import type { useMeterDraft } from './use-meter-draft';

export function meterDraftFields(draft: ReturnType<typeof useMeterDraft>): MemberMeterFields {
	return {
		codice: draft.str('codice'),
		cabinaPrimaria: draft.str('cabinaPrimaria'),
		dso: draft.str('dso'),
		verificatoGSE: draft.bool('verificatoGSE'),
		nome: draft.str('nome'),
		potenzaKwp: draft.str('potenzaKwp'),
		tecnologia: draft.str('tecnologia'),
		codiceGaudi: draft.str('codiceGaudi'),
		codiceUP: draft.str('codiceUP'),
		dataEntrataEsercizio: draft.str('dataEntrataEsercizio'),
		// Dalla data, anche quella che si sta scrivendo: l'API non accetta
		// `preEsistente` in scrittura, e un interruttore libero divergeva (INB-328).
		preEsistente: isPreEsistente([draft.str('dataEntrataEsercizio')]),
		pnrrGrantPct: draft.str('pnrrGrantPct'),
		tipologiaUtenza: draft.str('tipologiaUtenza'),
		numeroModuli: draft.str('numeroModuli'),
		potenzaModuloW: draft.str('potenzaModuloW'),
		potenzaInverterKw: draft.str('potenzaInverterKw'),
		inverterCount: draft.meter?.inverterCount ?? 0,
	};
}
